const aboutUsTimeline = document.querySelector(".about-us-timeline");

if (aboutUsTimeline) {
    const tabs = aboutUsTimeline.querySelectorAll(".timeline-item");
    // const boxes = aboutUsTimeline.querySelectorAll('.timeline-bar .box');
    const buttons = aboutUsTimeline.querySelectorAll(".js-timeline-button");

    aboutUsChangeTabs(buttons[0]);
    function aboutUsChangeTabs(btn) {
        const target = btn.nextElementSibling as HTMLElement;
        const alreadyExpanded =
            target.parentElement.classList.contains("active");
        // boxes.forEach((t) => {
        // 	const tab = t as HTMLElement;
        // 	if (tab.dataset.id == btn.parentNode.dataset.id) {
        // 		tab.classList.add("active");
        // 	} else {
        // 		tab.classList.remove("active");
        // 	}
        // });
        tabs.forEach((t) => {
            const tab = t as HTMLElement;
            if (tab == btn.parentElement) {
                tab.classList.add("active");
            } else {
                tab.classList.remove("active");
                vSlideUp(tab.querySelector(".js-timeline-content"));
            }
        });
        if (!alreadyExpanded) {
            setTimeout(() => {
                vSlideDown(target, 400);
            }, 500);
        }
    }

    for (const el of buttons) {
        const button = el.parentElement as HTMLButtonElement;
        button.addEventListener("click", (b) => {
            const btn = b.currentTarget as HTMLElement;
            aboutUsChangeTabs(btn.querySelector("button"));
        });
    }
}
